import { IconList } from "components/icons";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonList: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonBlocked.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconList  fixedWidth />
        </MprcIconButton>
    );
};
